module.exports = "/assets/data/0aa621c520c46a80be005ef962e518d0-WR1.data.json";